export const safari = /apple/i.test(navigator.vendor);
